'use client'

import React from 'react'

import { Footer, Header, Main, PageWrapper } from 'Components/Blocks'
import { Text } from 'Components/UI'

function DummyPage() {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <Text title28>This is dummy page</Text>
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export default DummyPage
